// extracted by mini-css-extract-plugin
module.exports = {"container":"case4_container__3ov-u","title":"case4_title__qbKfc","input":"case4_input__WFatM","text":"case4_text__2UEAq"};